// The platform session under the host (decision 064): the shell holds the
// token in the credential store; the pages call the platform themselves
// with it, as the companion's Rust side does, under the same client name
// (`companion/<version>`), so the platform judges the versions (F408).

import { configureApi } from "@/api";

import type { Host } from "./host";

/**
 * Points the API client at the platform the shell is set to, with the token
 * it holds now (none when signed out). Called before the first render, after
 * a login and after a sign-out.
 */
export async function syncHostSession(host: Host): Promise<{ apiUrl: string; signedIn: boolean }> {
  const [info, token] = await Promise.all([host.appInfo(), host.sessionToken()]);
  configureApi({ baseUrl: info.api_url, bearer: token, client: info.client });
  return { apiUrl: info.api_url, signedIn: token !== null };
}
